

const mapItems = items => items.map(item => (
  {
    id: item.productId,
    name: item.name,
    brand: item.brand,
    type: item.type,
    subtype: item.subtype,
    quantity: item.quantity,
    variant: `${item.size || ''} ${item.unitType || ''}`,
    price: item.originalPrice,
  }
));

export const getPurchaseEvent = ticketData => ({
  id: ticketData.orderNumber,
  items: mapItems(ticketData.items),
});

export const sendPurchaseEvent = (ticketData) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'purchase', getPurchaseEvent(ticketData));
  }
};

export const sendPageViewEvent = (pageTitle, pageLocation) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'page_view', {
      page_title: pageTitle,
      page_location: pageLocation,
    });
  }
};

export const sendViewItemEvent = (item) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'view_item', {
      items: [{
        id: item.categoryId,
        name: item.menuTitle || item.categoryName,
        brand: item.brand,
        type: item.type,
        subtype: item.subTypes ? item.subTypes.join() : '',
        quantity: 1,
        variant: `${item.size || ''} ${item.unitOfMeasurement || ''}`,
      }],
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/conversions.js